var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { attrs: { type: "card" } }, [
    _c(
      "div",
      { attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "card-title" }, [_vm._v("企业微信")]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.handleCreateCfg },
          },
          [_vm._v("添加")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm._l(_vm.records, function (cfg) {
          return _c(
            "el-card",
            { key: cfg.id, staticStyle: { width: "33%" } },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("el-tag", [_vm._v(_vm._s(cfg.corpId))]),
                  _vm._v(" "),
                  _c("el-tag", [_vm._v(_vm._s(cfg.corpName))]),
                  _vm._v(" "),
                  _c("el-tag", [_vm._v(_vm._s(cfg.agentId))]),
                  _vm._v(" "),
                  _c("el-tag", [_vm._v(_vm._s(cfg.agentName))]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleEditCfg(cfg, "desc_info")
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c("el-form-item", { attrs: { label: "来源渠道" } }, [
                    _c("span", [_vm._v(_vm._s(cfg.originChannel))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用密钥" } },
                    [
                      _c("span", [_vm._v(_vm._s(cfg.agentSecret))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(cfg, "agentSecret")
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业通讯录密钥" } },
                    [
                      _c("span", [_vm._v(_vm._s(cfg.cropAddrBookSecret))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(
                                cfg,
                                "cropAddrBookSecret"
                              )
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业通讯录token" } },
                    [
                      _c("span", [_vm._v(_vm._s(cfg.cropAddrBookToken))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(cfg, "cropAddrBookToken")
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业通讯录加密密钥" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(cfg.cropAddrBookEncodingAesKey)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(
                                cfg,
                                "cropAddrBookEncodingAesKey"
                              )
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户关系密钥" } },
                    [
                      _c("span", [_vm._v(_vm._s(cfg.customerRelationSecret))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(
                                cfg,
                                "customerRelationSecret"
                              )
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户关系token" } },
                    [
                      _c("span", [_vm._v(_vm._s(cfg.customerRelationToken))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(
                                cfg,
                                "customerRelationToken"
                              )
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户关系加密密钥" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(cfg.customerRelationEncodingAesKey)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(
                                cfg,
                                "customerRelationEncodingAesKey"
                              )
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "编辑配置",
              visible: _vm.updateDialogVisible,
              width: "70%",
              size: "small",
              top: "10px",
              "close-on-click-modal": false,
              "close-on-press-escape": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.updateDialogVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "updateCfgForm",
                attrs: { model: _vm.updateCfgForm, "label-width": "150px" },
              },
              [
                _vm.updateType === "desc_info"
                  ? [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业ID", prop: "corpId" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "40%" },
                            attrs: {
                              size: "small",
                              placeholder: "请属性企业ID",
                            },
                            model: {
                              value: _vm.updateCfgForm.corpId,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateCfgForm, "corpId", $$v)
                              },
                              expression: "updateCfgForm.corpId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称", prop: "corpName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入企业名称",
                            },
                            model: {
                              value: _vm.updateCfgForm.corpName,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateCfgForm, "corpName", $$v)
                              },
                              expression: "updateCfgForm.corpName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用ID", prop: "agentId" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "40%" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入应用ID",
                            },
                            model: {
                              value: _vm.updateCfgForm.agentId,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateCfgForm, "agentId", $$v)
                              },
                              expression: "updateCfgForm.agentId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用名称", prop: "agentName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入应用名称",
                            },
                            model: {
                              value: _vm.updateCfgForm.agentName,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateCfgForm, "agentName", $$v)
                              },
                              expression: "updateCfgForm.agentName",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.updateField[_vm.updateType],
                            prop: _vm.updateType,
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%" },
                            attrs: { size: "small", placeholder: "请输入" },
                            model: {
                              value: _vm.updateCfgForm[_vm.updateType],
                              callback: function ($$v) {
                                _vm.$set(_vm.updateCfgForm, _vm.updateType, $$v)
                              },
                              expression: "updateCfgForm[updateType]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.update },
                      },
                      [_vm._v("确 定")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.updateDialogVisible = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "新增配置",
              visible: _vm.dialogVisible,
              width: "70%",
              size: "small",
              top: "10px",
              "close-on-click-modal": false,
              "close-on-press-escape": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "cfgForm",
                attrs: {
                  model: _vm.cfgForm,
                  rules: _vm.rules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "来源类型", prop: "originChannel" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          size: "small",
                          disabled: "",
                        },
                        model: {
                          value: _vm.cfgForm.originChannel,
                          callback: function ($$v) {
                            _vm.$set(_vm.cfgForm, "originChannel", $$v)
                          },
                          expression: "cfgForm.originChannel",
                        },
                      },
                      _vm._l(_vm.comboboxList, function (item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { label: item.desc, value: item.code },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "企业ID", prop: "corpId" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "40%" },
                      attrs: { size: "small", placeholder: "请属性企业ID" },
                      model: {
                        value: _vm.cfgForm.corpId,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "corpId", $$v)
                        },
                        expression: "cfgForm.corpId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "企业名称", prop: "corpName" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: { size: "small", placeholder: "请输入企业名称" },
                      model: {
                        value: _vm.cfgForm.corpName,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "corpName", $$v)
                        },
                        expression: "cfgForm.corpName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "应用ID", prop: "agentId" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "40%" },
                      attrs: { size: "small", placeholder: "请输入应用ID" },
                      model: {
                        value: _vm.cfgForm.agentId,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "agentId", $$v)
                        },
                        expression: "cfgForm.agentId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "应用名称", prop: "agentName" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: { size: "small", placeholder: "请输入应用名称" },
                      model: {
                        value: _vm.cfgForm.agentName,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "agentName", $$v)
                        },
                        expression: "cfgForm.agentName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "应用密钥", prop: "agentSecret" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: { size: "small", placeholder: "请输入应用密钥" },
                      model: {
                        value: _vm.cfgForm.agentSecret,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "agentSecret", $$v)
                        },
                        expression: "cfgForm.agentSecret",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "企业通讯录密钥",
                      prop: "cropAddrBookSecret",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入企业通讯录密钥",
                      },
                      model: {
                        value: _vm.cfgForm.cropAddrBookSecret,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "cropAddrBookSecret", $$v)
                        },
                        expression: "cfgForm.cropAddrBookSecret",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "企业通讯录token",
                      prop: "cropAddrBookToken",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入企业通讯录token",
                      },
                      model: {
                        value: _vm.cfgForm.cropAddrBookToken,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "cropAddrBookToken", $$v)
                        },
                        expression: "cfgForm.cropAddrBookToken",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "企业通讯录加密密钥",
                      prop: "cropAddrBookEncodingAesKey",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入企业通讯录加密密钥",
                      },
                      model: {
                        value: _vm.cfgForm.cropAddrBookEncodingAesKey,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cfgForm,
                            "cropAddrBookEncodingAesKey",
                            $$v
                          )
                        },
                        expression: "cfgForm.cropAddrBookEncodingAesKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "客户关系密钥",
                      prop: "customerRelationSecret",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入客户关系密钥",
                      },
                      model: {
                        value: _vm.cfgForm.customerRelationSecret,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "customerRelationSecret", $$v)
                        },
                        expression: "cfgForm.customerRelationSecret",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "客户关系token",
                      prop: "customerRelationToken",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入客户关系token",
                      },
                      model: {
                        value: _vm.cfgForm.customerRelationToken,
                        callback: function ($$v) {
                          _vm.$set(_vm.cfgForm, "customerRelationToken", $$v)
                        },
                        expression: "cfgForm.customerRelationToken",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "客户关系加密密钥",
                      prop: "customerRelationEncodingAesKey",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        size: "small",
                        placeholder: "请输入客户关系加密密钥",
                      },
                      model: {
                        value: _vm.cfgForm.customerRelationEncodingAesKey,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cfgForm,
                            "customerRelationEncodingAesKey",
                            $$v
                          )
                        },
                        expression: "cfgForm.customerRelationEncodingAesKey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.createCfg } },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }